import React from 'react'
import { Route } from 'react-router-dom'
import { auth } from '../../../services/util/auth.service'
import { ChecklistOperacionalPermissions } from '../../../services/permission/menus'
import { ROTAS_CHECKLIST } from '../../../constants/checklist-operacional'
import ChecklistOperacionalMenu from './ChecklistOperacionalMenu/ChecklistOperacionalMenu'
import CadastroChecklist from './CadastroChecklist/CadastroChecklist'
import EstruturaChecklist from './EstruturaChecklist/EstruturaChecklist'
import PreenchimentoChecklist from './PreenchimentoChecklist/PreenchimentoChecklist'
import PreencherChecklist from './PreencherChecklist/PreencherChecklist'

export default function ChecklistOperacional() {
  return (
    <>
      <Route path={ROTAS_CHECKLIST.MENU} render={() => auth(<ChecklistOperacionalMenu />)} />
      <Route
        path={ROTAS_CHECKLIST.CADASTRO}
        render={() =>
          auth(<CadastroChecklist />, ChecklistOperacionalPermissions.CADASTRO_CHECKLIST)
        }
      />
      <Route
        path={ROTAS_CHECKLIST.ESTRUTURA}
        render={() =>
          auth(<EstruturaChecklist />, ChecklistOperacionalPermissions.CADASTRO_CHECKLIST)
        }
      />
      <Route
        path={ROTAS_CHECKLIST.PREENCHIMENTO}
        render={() =>
          auth(<PreenchimentoChecklist />, ChecklistOperacionalPermissions.PREENCHIMENTO_CHECKLIST)
        }
      />
      <Route
        path={ROTAS_CHECKLIST.PREENCHER}
        render={() =>
          auth(<PreencherChecklist />, ChecklistOperacionalPermissions.PREENCHIMENTO_CHECKLIST)
        }
      />
    </>
  )
}
